import useMainStore from '@/stores/main';
import {SELECTED_MODE} from '@/constants/main';

const formattedTopLiveList = (broad, count) => {
  if (!broad || broad.length === 0) {
    return [];
  }
  const formattedList = broad.map(
    ({
      totalViewCnt,
      userNick,
      broadTitle,
      broadNo,
      broadThumb,
      isPassword,
      broadGrade,
      subscriptionOnly,
      ...rest
    }) => ({
      ...rest,
      viewCount: totalViewCnt,
      userNickname: userNick,
      title: broadTitle,
      broadcastId: broadNo,
      thumbnailSrc: broadThumb,
      isPassword: isPassword === 'Y' ? 1 : 0,
      isAdult: Number(broadGrade),
      isBanner: false,
      isSubscriptionOnly: Number(subscriptionOnly) > 0, // 0: 일반방송, 2: 티어2 시청가능방송
    }),
  );

  const filteredList = formattedList.filter((item) => {
    // 비번방 아니고 && 성인방송 아니고 && 유료방송 아니고 숨기기 하지않은 스트리머 방송만 추출
    return (
      Number(item.broadType) !== 40 &&
      Number(item.isPassword) === 0 &&
      Number(item.isAdult) === 0 &&
      !item.isSubscriptionOnly &&
      item.broadCateNo !== '00130000' //토크&캠방 카테고리 제외
    );
  });

  if (filteredList.length <= count) {
    return filteredList;
  }

  const randomItems = [];
  const selectedIndices = new Set();

  // 추출한 인덱스가 중복일땐 리스트에 포함시키면 안되기 때문에 루프
  while (randomItems.length < count) {
    const randomIndex = Math.floor(Math.random() * filteredList.length);
    if (!selectedIndices.has(randomIndex)) {
      selectedIndices.add(randomIndex);
      randomItems.push(filteredList[randomIndex]);
    }
  }

  return randomItems;
};

export const buildTopLiveList = ({
  selectedMode,
  broadList,
  isSimplifyMode,
  banner,
  topLiveList,
}) => {
  let result = {
    count: 0,
    list: [],
  };

  const ad = banner?.main?.creatives?.[0];

  //인기모드
  if (selectedMode === SELECTED_MODE.POPULAR) {
    //간소화 일 경우
    if (isSimplifyMode) {
      // 간소화 모드 > 광고 있을때 광고만 노출
      if (banner.main.exist && ad) {
        const onlyAd = [ad];
        result = {
          count: onlyAd.length,
          list: onlyAd,
        };
      }
    }
    //간소화 아닐 경우
    else {
      //광고 있을때
      if (banner.main.exist && ad) {
        // topLiveList 비어있을때
        if (topLiveList.count === 0) {
          const formattedList = formattedTopLiveList(broadList, 3);
          formattedList.push(ad);
          result = {
            count: formattedList.length,
            list: formattedList,
          };
        }
        // topLiveList 광고 없이 콘텐츠만 있는 경우
        else if (topLiveList.list.every((item) => !item.isBanner)) {
          const updatedList = topLiveList.list.slice(0, 3);
          updatedList.push(ad);
          result = {
            count: updatedList.length,
            list: updatedList,
          };
        }
      }
      // 광고 없을 경우
      else {
        const formattedList = formattedTopLiveList(broadList, 4);
        result = {
          count: formattedList.length,
          list: formattedList,
        };
      }
    }
  }
  //선호 모드
  else if (selectedMode === SELECTED_MODE.PREFER) {
    //간소화
    if (isSimplifyMode) {
      //광고 있을때
      if (banner?.main?.exist && ad) {
        const onlyAd = [ad];
        result = {
          count: onlyAd.length,
          list: onlyAd,
        };
      }
    }
    //간소화 아닐경우
    else {
      const formattedList = broadList
        ? broadList.map(
            ({
              totalViewCnt,
              userNick,
              broadTitle,
              broadNo,
              broadThumb,
              ...rest
            }) => ({
              ...rest,
              viewCount: totalViewCnt,
              userNickname: userNick,
              title: broadTitle,
              broadcastId: broadNo,
              thumbnailSrc: broadThumb,
              isBanner: false,
            }),
          )
        : [];

      //광고있을때
      if (banner?.main?.exist && ad) {
        if (formattedList.length >= 4) {
          formattedList.splice(3, 1, ad);
        } else {
          formattedList.push(ad);
        }
      }
      result = {
        count: formattedList.length,
        list: formattedList,
      };
    }
  }

  return result;
};
